export default {
  name: "filter-params-list",
  props: ['searchData', 'isReadOnly', 'isReset', 'isSearchFace'],
  data() {
    return {
      timeOptions: { /*通行时间类型*/
        0: 'A Period Of Time',
        1: 'Office Hour',
        2: 'After Office Hour',
        3: 'Non-working Day',
        4: 'Customize'
      },
    }
  },
  mounted() { },
  methods: {
    // 删除当前搜索参数
    deleteField: function (item) {
      this.$parent.$refs.searchBar.getOptionData(true);
      let data = this.$parent.searchData.searchInfo;
      let i = data.findIndex((child) => {
        return item.title === child.title && item.type === child.type;
      });
      let field = data[i];
      if (field.params) {
        field.params = [];
      }
      if (field.keyword instanceof Array) {
        field.keyword = [];
      } else {
        field.keyword = '';
      }
      if (field.type === 'time-panel') {
        field.oldKeyword = {
          type: '',
          periodOfTime: {
            startDateTime: '',
            endDateTime: ''
          },
          customize: [
            {
              weeks: [0],
              startTime: '',
              endTime: ''
            }
          ]
        }
      }
      else if (field.type === 'date-group' || field.type === 'input-group' || field.type === 'validity' ||  field.type === 'date-time-group' || field.type === 'select-input' || field.type === 'multiple-select-input' || field.type === 'select-select' || field.type === 'select-select-default' || field.type === 'input-minutes') {
        field.content.forEach(date => {
          if (date.inputType === 'number' || date.type === 'number-input') {
            date.keyword = null;
          } else {
            date.keyword = '';
          }
        })
      }
      else if (field.type === 'range-division') {
        field.content.forEach(subItem => {
          subItem.keyword = '';
        });
        field.keyword = '';
      }
      else if (field.type === 'cascader' || field.type === 'cascader-multiple') {
        field.keyword = [];
      }
      else if(field.type === 'tree-select'){
        this.$parent.$refs.searchBar.treeSearchData = [];
        this.$parent.$refs.searchBar.clearTree(this.$parent.$refs.searchBar.filteredTreeData)
        field.keyword = [];
      }
      console.log(this.$parent.searchData.searchInfo)
      
      this.$parent.$refs.searchBar.refactoringData(this.$parent.searchData);
    },
    // 清除所有参数
    clearAll: function () {
      this.$parent.$refs.searchBar.reset(this.$parent.searchData);
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/filterParamsList.js